<template>
  <div>
    <input v-model="currentValue" type="number"
      class="border border-grey rounded-lg
            md:h-12 mx-4 mt-4 md:w-1/6 p-4 text-center
            sm:h-16 sm:text-xl sm:w-1/5">
  </div>
</template>

<script>
export default {
  name: 'NumberInput',
  props: ['initValue'],
  data () {
    return {
      currentValue: 0
    }
  },
  mounted () {
    if (this.initValue) {
      this.currentValue = this.initValue
    }
  },
  methods: {
    getValue () {
      return parseFloat(this.currentValue)
    },
    isValid () {
      return this.currentValue && this.currentValue > 0
    },
    reset () {
      this.currentValue = 0
    }
  }
}
</script>
